import { ActionTree } from 'vuex';
import { RootState } from '@/plugins/store';
import ErrorManager from '@/common/utils/ErrorManager';
import { AccountAction, AccountActionTypes } from './actions-types';
import AccountService from '../services/AccountService';
import { ACCOUNT } from './mutation-types';
import { AccountState } from './state';
import { SocieteDTO } from '@/models/SocieteDTO';

export const actions: ActionTree<AccountState, RootState> = {
    async [AccountAction.GET_SOCIETES]({commit}: AccountActionTypes, filtreProjetPublie: boolean): Promise<void>{
        return new Promise((resolve, reject) => {
            AccountService.getSocieteIds(filtreProjetPublie).then(async response => {
                if(response !== undefined || response?.status !== undefined){
                    if(response.status !== 200) {
                        await ErrorManager.processErrorCustomMessage(response.status, 'app.error.undefined');
                        reject();
                    }
                    let societeIds: number[] = response.data.map((societe: SocieteDTO) => societe.id);
                    // il n'y a pas de logo de Henelia (23), Financière Hervé (33), Cel (57)
                    societeIds = societeIds.filter((id: number) => id!==23 && id!==33 && id!==57);
                    const idsAlvazzi = [81, 82, 83, 87, 88, 89];
                    const alvazziPresent = societeIds.some(id => idsAlvazzi.includes(id));
                    if(alvazziPresent){
                        societeIds = societeIds.filter(id => !idsAlvazzi.includes(id));
                        societeIds.push(83);
                    }
                    societeIds.sort((a, b) => a - b);
                    commit(ACCOUNT.SET_SOCIETES, societeIds);
                    resolve();
                }else{
                    await ErrorManager.processErrorCustomMessage(response?.status, 'app.error.undefined');
                    reject();
                }
            }).catch( async error =>{
                await ErrorManager.processErrorCustomMessage(error, 'app.error.undefined');
                reject();
            });
        });
    }
};
